var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxDndSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0071f7",
    d: "M.914 10.531a.939.939 0 0 0-.914.857V19a4.436 4.436 0 0 0 4.428 4.371 4.333 4.333 0 0 0 3.9-2.385 4.536 4.536 0 0 0 3.9 2.385 4.455 4.455 0 0 0 4.428-4.428 4.394 4.394 0 0 0-4.385-4.471 4.333 4.333 0 0 0-3.9 2.385 4.538 4.538 0 0 0-3.9-2.385 4.376 4.376 0 0 0-2.656.914v-4a.862.862 0 0 0-.901-.855zm20.925 3.914a.8.8 0 0 0-.571.314l-1.957 2.614-2-2.557a.844.844 0 0 0-1.228-.143.893.893 0 0 0-.2 1.228l2.285 3.042-2.285 3a.893.893 0 0 0 .2 1.228.884.884 0 0 0 1.228-.143l1.957-2.614 1.943 2.614a.86.86 0 0 0 1.243.143.893.893 0 0 0 .229-1.228L20.411 18.9l2.271-3.043a.908.908 0 0 0-.186-1.242.937.937 0 0 0-.657-.17zM4.428 16.23a2.664 2.664 0 1 1-2.657 2.67 2.659 2.659 0 0 1 2.657-2.67zm7.842 0a2.664 2.664 0 1 1-2.657 2.67 2.672 2.672 0 0 1 2.657-2.67z",
    transform: "translate(8.575 3.047)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDndSmall);
export default __webpack_public_path__ + "static/media/box-dnd-small.24ec364cb245dc1dce2c7b774512f138.svg";
export { ForwardRef as ReactComponent };